import cn from 'classnames'
import React from 'react'

import type { IButtonPropsType } from 'components/uiKit/Button'
import type { KeyIconsType } from 'components/uiKit/Icon'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { testPropsEl } from 'utils/test/qaData'

import * as s from './TileButton.module.scss'

interface ITileButtonProps extends Omit<IButtonPropsType, 'children' | 'styleType'> {
  styleType?: 'base' | 'ghost' | 'stroke'
  onClick?: () => void
  children?: React.ReactNode
  description?: React.ReactNode
  icon?: KeyIconsType
  color?: string
}

const TileButton: React.FC<ITileButtonProps> = React.forwardRef<
  HTMLButtonElement,
  ITileButtonProps
>(
  (
    { name, onClick, active, description, children, styleType = 'base', icon, fluid, color },
    ref,
  ) => {
    return (
      <button
        {...testPropsEl('tileButton', { name })}
        className={cn(s.root, s[styleType], { [s.active]: active, [s.fluid]: fluid })}
        onClick={onClick}
        ref={ref}
      >
        <div className={s.header}>
          <span className={s.title}>{children}</span>
          {icon && (
            <div className={s.icon}>
              <Icon color={color} name={icon} size={KitSize.S} />
            </div>
          )}
        </div>

        {description && <div className={s.description}>{description}</div>}
      </button>
    )
  },
)

export default React.memo(TileButton) as typeof TileButton
